import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=baa96df6"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa96df6')) {
      api.createRecord('baa96df6', component.options)
    } else {
      api.reload('baa96df6', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=baa96df6", function () {
      api.rerender('baa96df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/send-list-conversation/quick-add/dialog.vue"
export default component.exports